// extracted by mini-css-extract-plugin
export default {"modalTitleContainer":"InvoicePreviewModal_modalTitleContainer__qTvp+","modalTitleButton":"InvoicePreviewModal_modalTitleButton__vbM-5"};